module.exports = __webpack_public_path__ + "img/history.7dfb2cd7.svg";